import { IAddress, IUser } from './user.model';

export interface IRecentActivity {
  amount: number;
  campaignData: any;
  campaignId: string;
  created: string;
  currentItemBid: number;
  currentRank: number;
  id: string;
  isAutoBid: boolean;
  optionInfo: any;
  payeeId: string;
  presetId: string;
  tieBreakerAdjustment: boolean;
  userId: string;
  userInfo: IUser;
  winningBid: boolean;
}

export interface IBidRequestParams {
  campaignId: string;
  presetId: string;
  bidAmount: number;
  client: string;
  email: string;
  name: string;
  phone: string;
  streetAddress?: IAddress;
  additionalInfoSelect?: string;
  additionalInfo?: string;
}


export enum ItemTypeText {
  featured = 'FEATURED',
  bestValue = 'GREAT DEAL',
  tranding = 'HOT ITEM',
}

export enum ItemsType {
  featured = 'featured',
  bestValue = 'bestValue',
  tranding = 'tranding',
}
